import { render } from "./AdminForums.vue?vue&type=template&id=6b80d0ee&scoped=true"
import script from "./AdminForums.vue?vue&type=script&lang=js"
export * from "./AdminForums.vue?vue&type=script&lang=js"

import "./AdminForums.vue?vue&type=style&index=0&id=6b80d0ee&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b80d0ee"]])

export default __exports__